import { render, staticRenderFns } from "./SimpleGalleryComponent.vue?vue&type=template&id=14d21398"
import script from "./SimpleGalleryComponent.vue?vue&type=script&lang=js"
export * from "./SimpleGalleryComponent.vue?vue&type=script&lang=js"
import style0 from "./SimpleGalleryComponent.vue?vue&type=style&index=0&id=14d21398&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports